var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index py-5"},[_c('span',{staticClass:"d-flex flex-row page-title"},[_vm._v(_vm._s(_vm.$t("intranet.title.page.appellation.list")))]),_c('div',{staticClass:"list-container"},[_c('AveineAppellationList',{attrs:{"APIbaseURL":_vm.APIbaseURL,"adminMode":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }